"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentType = void 0;
exports.AttachmentType = {
    CaseLabels: "CASE_LABELS",
    ShippingLabels: "SHIPPING_LABELS",
    ShippingLabelsZpl: "SHIPPING_LABELS_ZPL",
    CaseLabelsZpl: "CASE_LABELS_ZPL",
    CaseSsccLabelsZpl: "CASE_SSCC_LABELS_ZPL",
    CaseSsccLabels: "CASE_SSCC_LABELS",
    PalletLabels: "PALLET_LABELS",
    PalletLabelsZpl: "PALLET_LABELS_ZPL",
    Bol: "BOL",
    VendorGuidelines: "VENDOR_GUIDELINES",
    PackingSlip: "PACKING_SLIP",
    SignedBol: "SIGNED_BOL",
    PackingList: "PACKING_LIST",
    CommercialInvoice: "COMMERCIAL_INVOICE",
    PrepInstructions: "PREP_INSTRUCTIONS",
    Asn856: "ASN_856",
    Po850: "PO_850",
};
//# sourceMappingURL=attachment-type.js.map